export default "/images/vendor/flag-icon-css/flags/1x1/id.svg?0b7fa609d99165dc53779622ac443791";